import apiClient from '../../services/apiClient';

export default {
	namespaced: true,
	state: {
		salesValues: {
			amount: {
				days: null,
				weeks: null,
				months: null,
			},
			revenue: {
				days: null,
				weeks: null,
				months: null,
			},
			average: {
				days: null,
				weeks: null,
				months: null,
			},
		},
	},
	getters: {
		amountDays(state) {
			return state.salesValues.amount.days;
		},
		amountWeeks(state) {
			return state.salesValues.amount.weeks;
		},
		amountMonths(state) {
			return state.salesValues.amount.months;
		},
		revenueDays(state) {
			return state.salesValues.revenue.days;
		},
		revenueWeeks(state) {
			return state.salesValues.revenue.weeks;
		},
		revenueMonths(state) {
			return state.salesValues.revenue.months;
		},
		averageDays(state) {
			return state.salesValues.average.days;
		},
		averageWeeks(state) {
			return state.salesValues.average.weeks;
		},
		averageMonths(state) {
			return state.salesValues.average.months;
		},
	},
	mutations: {
		SET_SALES_VALUES_AMOUNT_DAYS(state, sales) {
			state.salesValues.amount.days = sales;
		},
		SET_SALES_VALUES_AMOUNT_WEEKS(state, sales) {
			state.salesValues.amount.weeks = sales;
		},
		SET_SALES_VALUES_AMOUNT_MONTHS(state, sales) {
			state.salesValues.amount.months = sales;
		},
		SET_SALES_VALUES_REVENUE_DAYS(state, sales) {
			state.salesValues.revenue.days = sales;
		},
		SET_SALES_VALUES_REVENUE_WEEKS(state, sales) {
			state.salesValues.revenue.weeks = sales;
		},
		SET_SALES_VALUES_REVENUE_MONTHS(state, sales) {
			state.salesValues.revenue.months = sales;
		},
		SET_SALES_VALUES_AVERAGE_DAYS(state, sales) {
			state.salesValues.average.days = sales;
		},
		SET_SALES_VALUES_AVERAGE_WEEKS(state, sales) {
			state.salesValues.average.weeks = sales;
		},
		SET_SALES_VALUES_AVERAGE_MONTHS(state, sales) {
			state.salesValues.average.months = sales;
		},
		CLEAR_STORE(state) {
			state.salesValues.amount.days = null;
			state.salesValues.amount.weeks = null;
			state.salesValues.amount.months = null;
			state.salesValues.revenue.days = null;
			state.salesValues.revenue.weeks = null;
			state.salesValues.revenue.months = null;
			state.salesValues.average.days = null;
			state.salesValues.average.weeks = null;
			state.salesValues.average.months = null;
		}
	},
	actions: {
		async initAmountDays({commit}) {
			await apiClient.get('analytics/sales/amount/days').then(response => {
				commit('SET_SALES_VALUES_AMOUNT_DAYS', response.data);
			}).catch(err => {

			});
		},
		async initAmountWeeks({commit}) {
			await apiClient.get('analytics/sales/amount/weeks').then(response => {
				commit('SET_SALES_VALUES_AMOUNT_WEEKS', response.data);
			}).catch(err => {

			});
		},
		async initAmountMonths({commit}) {
			await apiClient.get('analytics/sales/amount/months').then(response => {
				commit('SET_SALES_VALUES_AMOUNT_MONTHS', response.data);
			}).catch(err => {

			});
		},
		async initRevenueDays({commit}) {
			await apiClient.get('analytics/sales/revenue/days').then(response => {
				commit('SET_SALES_VALUES_REVENUE_DAYS', response.data);
			}).catch(err => {

			});
		},
		async initRevenueWeeks({commit}) {
			await apiClient.get('analytics/sales/revenue/weeks').then(response => {
				commit('SET_SALES_VALUES_REVENUE_WEEKS', response.data);
			}).catch(err => {

			});
		},
		async initRevenueMonths({commit}) {
			await apiClient.get('analytics/sales/revenue/months').then(response => {
				commit('SET_SALES_VALUES_REVENUE_MONTHS', response.data);
			}).catch(err => {

			});
		},
		async initAverageDays({commit}) {
			await apiClient.get('analytics/sales/average/days').then(response => {
				commit('SET_SALES_VALUES_AVERAGE_DAYS', response.data);
			}).catch(err => {

			});
		},
		async initAverageWeeks({commit}) {
			await apiClient.get('analytics/sales/average/weeks').then(response => {
				commit('SET_SALES_VALUES_AVERAGE_WEEKS', response.data);
			}).catch(err => {

			});
		},
		async initAverageMonths({commit}) {
			await apiClient.get('analytics/sales/average/months').then(response => {
				commit('SET_SALES_VALUES_AVERAGE_MONTHS', response.data);
			}).catch(err => {

			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}
